/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LadderRatingConfig
 */
export interface LadderRatingConfig {
    /**
     * 
     * @type {number}
     * @memberof LadderRatingConfig
     */
    initialRating?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderRatingConfig
     */
    kFactor?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderRatingConfig
     */
    provisionalGames?: number;
    /**
     * 
     * @type {number}
     * @memberof LadderRatingConfig
     */
    initialVolatility?: number;
}

/**
 * Check if a given object implements the LadderRatingConfig interface.
 */
export function instanceOfLadderRatingConfig(value: object): value is LadderRatingConfig {
    return true;
}

export function LadderRatingConfigFromJSON(json: any): LadderRatingConfig {
    return LadderRatingConfigFromJSONTyped(json, false);
}

export function LadderRatingConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderRatingConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'initialRating': json['initialRating'] == null ? undefined : json['initialRating'],
        'kFactor': json['kFactor'] == null ? undefined : json['kFactor'],
        'provisionalGames': json['provisionalGames'] == null ? undefined : json['provisionalGames'],
        'initialVolatility': json['initialVolatility'] == null ? undefined : json['initialVolatility'],
    };
}

export function LadderRatingConfigToJSON(json: any): LadderRatingConfig {
    return LadderRatingConfigToJSONTyped(json, false);
}

export function LadderRatingConfigToJSONTyped(value?: LadderRatingConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initialRating': value['initialRating'],
        'kFactor': value['kFactor'],
        'provisionalGames': value['provisionalGames'],
        'initialVolatility': value['initialVolatility'],
    };
}

